import React from 'react'
import pdfIcon from '../../assets/images/pdfIcons.svg'
import docIcon from '../../assets/images/docIcon.svg'
import IconArrow from '../../assets/icons/Vector (1).svg'
import arrowleft from '../../assets/icons/arrow-left.svg'
import brifcase from '../../assets/icons/briefcase.svg'
import firstine from '../../assets/icons/file-list.svg'
import user from '../../assets/icons/user.svg'
import stetho from '../../assets/icons/stethoscope.svg'
import first from '../../assets/icons/first-aid.svg'
import briefcase2 from '../../assets/icons/briefcase-2-line.svg'
import graduation from '../../assets/icons/graduation-cap-line.svg'
import suitcase from '../../assets/icons/suitcase-line.svg'
import firstKit from '../../assets/icons/first-aid-kit.svg'
import arrowgo from '../../assets/icons/arrowgo.svg'
import './PhysicianForm.css'
const CompleteForm = ({ values, handleClick, registrationType }) => {



    return (
        <div className=" text-medium text-gray-500   rounded-lg w-full" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div className="flex items-center space-x-1 mb-4">
                <div className='pl-4'>
                    <img src={brifcase} alt="License Icon" className="w-6 h-6" />
                </div>
                <h3 className="label-medium pt-2">Job Information</h3>

            </div>
            <div className='border-t border-l'>

                <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                    <div className='pl-4 flex  space-x-1 items-center'>
                        <div className=''>
                            <img src={firstine} alt="License Icon" className="w-6 h-6 " />
                        </div>
                        <h3 className="label-medium pt-2">License Information</h3>
                    </div>
                </div>

                <div className=" pt-1 ml-4 ">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6 ">

                        <div className="lg:col-span-1 border-r">
                            <div>
                                <label className='inter-font2'>
                                    SCFHS License Number
                                </label>
                                <div className='text-[#0A0D14] inter-font'>
                                    {values.licenseNumber}
                                </div>
                            </div>
                        </div>
                        <div className="lg:col-span-1 ">
                            <div className="flex flex-col items-center justify-center">
                                <div>
                                    <label className='inter-font2'>
                                        SCFHS License Expiry Date
                                    </label>
                                    <div className='text-[#DF1C41] inter-font'>
                                        {values.licenseExpiryDate}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="lg:col-span-1">

                        </div>
                    </div>





                </div>
                <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                    <div className='pl-4 flex items-center space-x-1 '>
                        <div className=' '>
                            <img src={user} alt="License Icon" className="w-6 h-6" />
                        </div>
                        <h3 className="label-medium pt-2" >Practitioner Information</h3>
                    </div>
                </div>

                <div className="pt-1 ml-4">
                    {/* First Row: Two Columns */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-6 pb-6">

                        {registrationType !== 'External' && (
                            <div className="lg:col-span-1 border-r">
                                <label className='inter-font2'>Arabic Name</label>
                                <div className="text-[#0A0D14] inter-font">{values.firstArabicName}</div>
                            </div>
                        )}
                        <div className="lg:col-span-1">
                            <label className='inter-font2'>English Name</label>
                            <div className="text-[#0A0D14] inter-font">{values.firstName}</div>
                        </div>
                    </div>
                    <hr />

                    {/* Second Row: Three Columns */}



                    {/* Third Row: Three Columns */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                        <div className="lg:col-span-1 border-r">
                            <label className='inter-font2'>Nationality</label>
                            <div className="text-[#0A0D14] inter-font">{values.nationality}</div>
                        </div>
                        <div className="lg:col-span-1 ">
                            <label className='inter-font2'>Identity #</label>
                            <div className="text-[#0A0D14] inter-font">{values.identityNumber}</div>
                        </div>
                        <div className="lg:col-span-1">

                        </div>
                    </div>
                    <hr />

                    {/* Fourth Row: Three Columns */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                        <div className="lg:col-span-1 border-r">
                            <label className='inter-font2'>Date of Birth</label>
                            <div className="text-[#0A0D14] inter-font">{values.dateOfBirth}</div>
                        </div>
                        <div className="lg:col-span-1 border-r">
                            <label className='inter-font2'>Place Of Birth</label>
                            <div className="text-[#0A0D14] inter-font">{values.placeOfBirth}</div>
                        </div>
                        <div className="lg:col-span-1">
                            <label className='inter-font2'>Gender</label>
                            <div className="text-[#0A0D14] inter-font">{values.gender}</div>
                        </div>
                    </div>
                    <hr />
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                        <div className="lg:col-span-1 border-r">
                            <label className='inter-font2'>Email</label>
                            <div className="text-[#0A0D14] inter-font">{values.email}</div>
                        </div>
                        <div className="lg:col-span-1 ">
                            <label className='inter-font2'>Phone Number</label>
                            <div className="text-[#0A0D14] inter-font">{values.phoneNumber}</div>
                        </div>

                    </div>
                </div>

                {registrationType !== 'External' && (
                    <>
                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className="flex items-center space-x-1 ">
                                <div className='pl-4'>
                                    <img src={stetho} alt="License Icon" className="w-6 h-6" />
                                </div>

                                <h3 className="label-medium pt-2">Personal Information</h3>
                            </div>
                        </div>

                        <div className=" pt-1 ml-4 ">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                                <div className="lg:col-span-1 border-r">
                                    <div>
                                        <label className='inter-font2'>
                                            Practitioner Type
                                        </label>
                                        <div className='text-[#0A0D14] inter-font'>
                                            {values.practitionerType}
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:col-span-1">

                                    <div>
                                        <label className='inter-font2'>
                                            Practitioner Level
                                        </label>
                                        <div className='text-[#0A0D14] inter-font'>
                                            {values.practitionerLevels}
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:col-span-1">


                                </div>



                            </div>
                        </div>
                    </>
                )}

                <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                    <div className="flex items-center space-x-1 ">
                        <div className='pl-4'>
                            <img src={first} alt="License Icon" className="w-6 h-6 " />
                        </div>
                        <h3 className="label-medium pt-2">Medical Specialties</h3>
                    </div>
                </div>

                <div className="pt-1 ml-4 max-w-full">
                    <div className="flex gap-4 pt-7 pb-7 flex-wrap">
                        {values?.medicalSpecialties?.map((label, index) => (
                            <span
                                key={index}
                                className="cursor-pointer leading-[16px] text-[12px] text-xs font-medium px-2.5 py-0.5 rounded border h-[24px] bg-[#2D9F75] text-[#fff] border-[#E2E4E9]"
                            >
                                {label?.name}
                            </span>
                        ))}
                    </div>
                </div>


                <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                    <div className="flex items-center space-x-1 ">
                        <div className='pl-4'>
                            <img src={briefcase2} alt="License Icon" className="w-6 h-6" />
                        </div>

                        <h3 className="label-medium pt-2">Job Information</h3>
                    </div>
                </div>

                <div className=" pt-1 ml-4 ">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                        <div className="lg:col-span-1 border-r">
                            <div>
                                <label className='inter-font2'>
                                    Current Job Organisation
                                </label>
                                <div className='text-[#0A0D14]'>
                                    {values.currentJobOrganization}
                                </div>
                            </div>
                        </div>
                        <div className="lg:col-span-1 border-r">

                            <div>
                                <label className='inter-font2'>
                                    Current Job Title
                                </label>
                                <div className='text-[#0A0D14]'>
                                    {values.currentJobTitle}
                                </div>
                            </div>
                        </div>
                        <div className="lg:col-span-1">

                            <div>
                                <label className='inter-font2'>
                                    Hospital Preference
                                </label>
                                <div className='text-[#0A0D14]'>
                                    {values.siteIds.map((file) => {


                                        return (
                                            <div
                                                key={file.value} // Use a unique key, assuming `file.value` is unique
                                                className="bg-[#F0F4F8] p-2 mb-2 rounded-md w-[185px] truncate"
                                                title={file.label}


                                            >
                                                {file.label}
                                            </div>
                                        );
                                    })}



                                </div>
                            </div>
                        </div>



                    </div>
                </div>


                <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                    <div className="flex items-center space-x-1 ">
                        <div className='pl-4'>
                            <img src={graduation} alt="License Icon" className="w-6 h-6" />
                        </div>

                        <h3 className="label-medium pt-2">Education Documents</h3>
                    </div>
                </div>

                <div className=" pt-1 ml-4 ">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">

                        {values?.educationDocument?.map((file) => {


                            const filePath = file?.path || file;
                            const fileExtension = filePath?.split?.('.')?.pop()?.toLowerCase(); // Get the file extension

                            let fileIcon = null;

                            // Check file type and assign the appropriate icon
                            if (fileExtension === 'pdf') {
                                fileIcon = pdfIcon; // Set PDF icon
                            } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                                fileIcon = docIcon; // Set DOC icon
                            }
                            return (

                                <div
                                    key={file.path}
                                    className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                                >
                                    {fileIcon && (
                                        <img
                                            src={fileIcon}
                                            alt="file icon"
                                            className="w-[40px] h-[40px] flex-shrink-0"
                                        />
                                    )}

                                    <div className="flex flex-col w-full">
                                        <div className="flex justify-between items-center w-full">
                                            <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                                {filePath}
                                            </div>


                                        </div>


                                    </div>
                                </div>
                            )
                        })}
                    </div>





                </div>
                <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                    <div className="flex items-center space-x-1 ">
                        <div className='pl-4'>
                            <img src={suitcase} alt="License Icon" className="w-6 h-6 " />
                        </div>

                        <h3 className="label-medium pt-2">Experience Documents</h3>
                    </div>
                </div>

                <div className=" pt-1 ml-4 ">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">



                        {values?.experienceDocument?.map((file) => {



                            const filePath = file?.path || file;
                            const fileExtension = filePath?.split?.('.')?.pop()?.toLowerCase();// Get the file extension

                            let fileIcon = null;

                            // Check file type and assign the appropriate icon
                            if (fileExtension === 'pdf') {
                                fileIcon = pdfIcon; // Set PDF icon
                            } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                                fileIcon = docIcon; // Set DOC icon
                            }
                            return (

                                <div
                                    key={file.path}
                                    className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                                >
                                    {fileIcon && (
                                        <img
                                            src={fileIcon}
                                            alt="file icon"
                                            className="w-[40px] h-[40px] flex-shrink-0"
                                        />
                                    )}

                                    <div className="flex flex-col w-full">
                                        <div className="flex justify-between items-center w-full">
                                            <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                                {filePath}
                                            </div>


                                        </div>


                                    </div>
                                </div>
                            )
                        })}
                    </div>





                </div>
                <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                    <div className="flex items-center space-x-1 ">
                        <div className='pl-4'>
                            <img src={firstKit} alt="License Icon" className="w-6 h-6" />
                        </div>


                        <h3 className="label-medium pt-2">Practitioner Specialties Documents</h3>
                    </div>
                </div>

                <div className=" pt-1 ml-4 ">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">



                        {values?.practitionerSpecialtiesDocuments?.map((file) => {

                            const filePath = file?.path || file;
                            const fileExtension = filePath?.split?.('.')?.pop()?.toLowerCase();// Get the file extension

                            let fileIcon = null;

                            // Check file type and assign the appropriate icon
                            if (fileExtension === 'pdf') {
                                fileIcon = pdfIcon; // Set PDF icon
                            } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                                fileIcon = docIcon; // Set DOC icon
                            }
                            return (

                                <div
                                    key={file.path}
                                    className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                                >
                                    {fileIcon && (
                                        <img
                                            src={fileIcon}
                                            alt="file icon"
                                            className="w-[40px] h-[40px] flex-shrink-0"
                                        />
                                    )}

                                    <div className="flex flex-col w-full">
                                        <div className="flex justify-between items-center w-full">
                                            <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                                {filePath}
                                            </div>


                                        </div>


                                    </div>
                                </div>
                            )
                        })}
                    </div>





                </div>

                {(values?.requestAttachments.length > 0 &&
                    <>
                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className="flex items-center space-x-1 ">
                                <div className='pl-4'>
                                    <img src={arrowgo} alt="License Icon" className="w-6 h-6" />
                                </div>
                                <h3 className="label-medium pt-2">Request Attachments</h3>
                            </div>
                        </div>

                        <div className=" pt-1 ml-4 ">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">

                                {values?.requestAttachments?.map((file) => {

                                    const filePath = file?.path || file;
                                    const fileExtension = filePath?.split?.('.')?.pop()?.toLowerCase(); // Get the file extension

                                    let fileIcon = null;

                                    // Check file type and assign the appropriate icon
                                    if (fileExtension === 'pdf') {
                                        fileIcon = pdfIcon; // Set PDF icon
                                    } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                                        fileIcon = docIcon; // Set DOC icon
                                    }
                                    return (

                                        <div
                                            key={file.path}
                                            className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                                        >
                                            {fileIcon && (
                                                <img
                                                    src={fileIcon}
                                                    alt="file icon"
                                                    className="w-[40px] h-[40px] flex-shrink-0"
                                                />
                                            )}

                                            <div className="flex flex-col w-full">
                                                <div className="flex justify-between items-center w-full">
                                                    <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                                        {filePath}
                                                    </div>


                                                </div>


                                            </div>
                                        </div>
                                    )
                                })}
                            </div>





                        </div>
                    </>
                )}

                <div className='flex justify-end items-center'>
                    <div className='flex items-center justify-between w-[300px]'>
                        <button type="button"
                            onClick={() => handleClick(4)}
                            class="w-[128px] h-[40px] text-[#007A63] flex justify-center items-center  border border-[#007A63]  focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm  text-center  [#007A63] [#007A63] :text-white">
                            <img src={arrowleft} alt='logo' style={{ paddingRight: '12px' }} />
                            Previous

                        </button>
                        <button
                            type="submit"

                            className="text-white bg-[#007A63] flex justify-center items-center focus:ring-[#007A63] focus:ring-1 focus:outline-none w-[128px] h-[40px] font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                        >
                            {false ? (
                                <svg
                                    aria-hidden="true"
                                    className="inline w-4 h-4 text-gray-200 animate-spin  fill-green-500"
                                    viewBox="0 0 100 101"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"
                                    />
                                </svg>
                            ) : (
                                <>
                                    Submit
                                    <img src={IconArrow} alt="logo" style={{ paddingLeft: '12px' }} />
                                </>
                            )}
                        </button>

                    </div>
                </div>
            </div>



        </div >
    )
}

export default CompleteForm
